export default __webpack_public_path__ + "static/media/detail_01.8d0ab9a1.png";